"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var config = {
    api: {
        adminApiBaseUrl: 'https://ysyuu83xi9.execute-api.us-east-1.amazonaws.com/prod/admin/graphql',
        foodOpsApiBaseUrl: 'https://ysyuu83xi9.execute-api.us-east-1.amazonaws.com/prod/foodops/graphql',
        siteStaffApiBaseUrl: 'https://ysyuu83xi9.execute-api.us-east-1.amazonaws.com/prod/site-staff/graphql',
        patientApiBaseUrl: 'https://ysyuu83xi9.execute-api.us-east-1.amazonaws.com/prod/patient/v2/graphql',
        commonApi: 'https://ysyuu83xi9.execute-api.us-east-1.amazonaws.com/prod/common',
        apiKey: 'xablauapikeyxablau123-prod',
        webSocketBaseUrl: 'wss://2assnrw8ed.execute-api.us-east-1.amazonaws.com/prod'
    },
    cloudfront: 'd1c1rgjojpvagl.cloudfront.net',
    cognito: {
        adminUserPoolId: 'us-east-1_Ml6VYlcUU',
        adminUserPoolClientId: '5ubhhp6ajrtndviku83k2t4j3r',
        foodOpsUserPoolId: 'us-east-1_jNyYVnvh0',
        foodOpsUserPoolClientId: 'or7ld7ofbeeptbc6hvdbos62g',
        patientUserPoolId: 'us-east-1_imsm2yllF',
        patientUserPoolClientId: '1dekp6244mvdu1nme7gadgp19d',
        siteStaffUserPoolId: 'us-east-1_jeywUKEgw',
        siteStaffUserPoolClientId: '51t6pjnfp08r2pk98j63du2rrf'
    },
    pinpoint: '818a479129954e0fbfdc4487a5b06421',
    region: 'us-east-1',
    secretsManager: {
        mapsApiKey: 'AIzaSyDLP8REBjQ8Goq1vIyX522we4aMnByRU7k'
    }
};
exports.default = config;
